// extracted by mini-css-extract-plugin
module.exports = {"excerpt":"CommentaryItem_excerpt__bYuuc"};